import { AlertTriangle, CheckCircle2 } from "lucide-react";

const TRAFFIC = {
  green: "border-emerald-300 bg-emerald-50 text-emerald-950",
  yellow: "border-amber-300 bg-amber-50 text-amber-950",
  red: "border-rose-300 bg-rose-50 text-rose-950",
  gray: "border-slate-200 bg-slate-50 text-slate-700",
};

/**
 * Semáforo compacto para alertas FIEL (empresa o representante).
 * @param {{ light?: string, days?: number|null, compact?: boolean, label?: string }} props
 */
export default function FielCertificateAlertBadge({ light, days, compact = false, label }) {
  const tone = TRAFFIC[light] || TRAFFIC.gray;
  const text =
    label ||
    (light === "green"
      ? `Vigente${days != null ? ` · ${days} d` : ""}`
      : light === "yellow"
        ? `Por vencer${days != null ? ` · ${days} d` : ""}`
        : light === "red"
          ? days != null && days < 0
            ? `Vencida · ${-days} d`
            : "Urgente"
          : "Sin FIEL");

  if (compact && (light === "green" || !light)) {
    return null;
  }

  return (
    <span
      className={`inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded-sm border ${tone}`}
      data-testid={`fiel-alert-badge-${light || "gray"}`}
    >
      {light === "green" ? (
        <CheckCircle2 className="w-3 h-3" aria-hidden />
      ) : light === "gray" ? null : (
        <AlertTriangle className="w-3 h-3" aria-hidden />
      )}
      {text}
    </span>
  );
}

export function worstFielAlertFromItem(item) {
  const alerts = Array.isArray(item?.certificate_alerts) ? item.certificate_alerts : [];
  if (!alerts.length && item?.certificate_worst_light) {
    return { traffic_light: item.certificate_worst_light, days_remaining: null, cert_type: "FIEL" };
  }
  const rank = { red: 0, yellow: 1, gray: 2, green: 3 };
  return [...alerts].sort(
    (a, b) => (rank[a.traffic_light] ?? 9) - (rank[b.traffic_light] ?? 9),
  )[0] || null;
}
